var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedRandomness1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9513 175C57.9542 174.639 56.918 174.355 55.9599 173.896C52.6362 172.323 50.4953 169.744 49.547 166.177C44.4929 147.33 39.4193 128.482 34.3652 109.624C31.4031 98.5736 28.441 87.5327 25.5083 76.4723C23.6216 69.369 27.1506 63.2721 34.2088 61.3863C49.9674 57.1654 65.726 52.9542 81.4846 48.743C84.0752 48.0493 86.6462 47.3165 89.2466 46.6912C95.6302 45.1474 101.74 48.6648 103.461 54.9963C107.185 68.6655 110.822 82.3543 114.488 96.0333C118.857 112.35 123.227 128.667 127.578 144.985C129.406 151.834 125.974 157.931 119.092 159.807C100.626 164.819 82.1396 169.734 63.6633 174.688C63.4482 174.746 63.2527 174.893 63.0474 174.99H58.9416L58.9513 175ZM93.9781 106.498C93.4697 105.804 92.9712 104.788 92.1891 104.084C85.9228 98.5053 79.6174 92.975 73.3022 87.4546C70.9267 85.3734 68.7174 85.989 67.7007 88.9788C65.0612 96.7661 62.4315 104.544 59.8018 112.331C58.8634 115.115 59.01 115.643 61.1705 117.548C67.3585 122.991 73.5564 128.433 79.7445 133.875C82.0614 135.908 84.3587 135.292 85.3656 132.341C88.0735 124.378 90.7618 116.405 93.4599 108.442C93.6261 107.934 93.7434 107.416 93.9878 106.498H93.9781Z",
    fill: "url(#paint0_linear_71_693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 48.7331C174.413 51.7816 173.778 54.8203 173.231 57.8687C171.011 70.3362 168.831 82.8134 166.632 95.2808C164.53 107.172 162.428 119.072 160.336 130.963C159.74 134.373 159.202 137.793 158.528 141.174C157.237 147.632 151.206 151.482 144.392 150.3C142.232 149.928 140.071 149.577 137.92 149.127C137.52 149.039 136.913 148.57 136.904 148.238C136.62 143.118 134.792 138.34 133.531 133.455C131.351 125.023 129.054 116.62 126.756 108.207C126.492 107.25 126.708 106.752 127.538 106.185C134.235 101.681 140.276 96.4826 144.646 89.5845C146.543 86.5946 147.98 83.4094 148.4 79.8528C148.957 75.2215 146.65 71.0103 142.535 69.0367C138.438 67.0727 133.678 67.9423 130.413 71.2546C130.207 71.4598 130.012 71.6748 129.718 71.9874C126.815 65.7732 122.084 63.5846 115.358 65.4997C114.537 62.4414 113.676 59.4223 112.904 56.3738C111.878 52.3483 110.773 48.3716 108.006 45.0886C104.663 41.1315 100.489 38.6497 95.3565 37.829C95.1708 37.7997 94.9948 37.7215 94.8286 37.6727C94.9655 28.4003 102.336 23.9839 108.984 25.1662C127.069 28.4003 145.164 31.5464 163.259 34.6828C166.651 35.2691 169.956 36.0996 172.097 38.9819C173.338 40.6527 174.062 42.7144 175.02 44.6001V48.7038L175 48.7331Z",
    fill: "url(#paint1_linear_71_693)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_693",
    x1: 76.5345,
    y1: 46.3296,
    x2: 76.5345,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_71_693",
    x1: 134.924,
    y1: 24.978,
    x2: 134.924,
    y2: 150.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedRandomness1);
export default __webpack_public_path__ + "static/media/Verified_Randomness-1.808c5842404ff6e1b60c239fc910d367.svg";
export { ForwardRef as ReactComponent };